// extracted by mini-css-extract-plugin
export var button = "_bg-0";
export var icon = "_bg-1";